const dark = {
  app: {
    actionSheet: {
      primary: {
        closeIcon: 'base.neutrals.white',
        topBg: 'base.blues.blue500',
        imageBorder: 'base.neutrals.gray300',
      },
      warn: {
        closeIcon: 'base.neutrals.gray900',
        topBg: 'base.yellows.yellow500',
        imageBorder: 'base.neutrals.gray300',
      },
      soft: {
        closeIcon: 'base.neutrals.gray900',
        topBg: 'base.blues.blue200',
        imageBorder: 'base.neutrals.gray300',
      },
    },
    googleAd: {
      foreground: 'base.neutrals.gray500',
    },
    icon: 'base.neutrals.white',
    alert: {
      success: {
        bg: 'base.greens.green900',
        foreground: 'base.greens.green100',
      },
      warn: {
        bg: 'base.yellows.yellow900',
        foreground: 'base.yellows.yellow100',
      },
    },
    appBanner: {
      foreground: 'base.neutrals.gray900',
    },
    article: {
      offersListBg: 'base.neutrals.gray900',
      authorInfoBorder: 'base.neutrals.gray750',
      border: 'base.neutrals.gray900',
      categoryForeground: 'base.blues.blue300',
      partnerOfferBorder: 'base.neutrals.gray750',
      partnerOfferForeground: 'base.neutrals.gray200',
      partnerOfferForegroundHighlight: 'base.blues.blue300',
      readMoreBg: 'base.neutrals.gray750',
      readMoreIconBg: 'base.neutrals.gray200',
      readMoreIconForeground: 'base.neutrals.white',
      recommendWishlistKeywordBg: 'base.blues.blue500',
      recommendWishlistKeywordForeground: 'base.neutrals.white',
      recommendWishlistKeywordHighlightedForeground: 'base.neutrals.white',
      tableBorder: 'base.neutrals.gray750',
    },
    articles: {
      categoryCarouselBg: 'base.neutrals.gray750',
    },
    articlesHero: {
      categoryBorder: 'base.neutrals.white',
      categoryForeground: 'base.neutrals.white',
      dateForeground: 'base.neutrals.white',
      dotDivisor: 'base.neutrals.white',
      titleForeground: 'base.neutrals.white',
      usernameForeground: 'base.neutrals.white',
    },
    addKeywordWithMaxPrice: {
      backgroundColor: 'base.blues.blue500',
      headingForeground: 'base.neutrals.white',
    },
    blackFridayGlossary: {
      headerForeground: 'base.blues.blue400',
      selectedLetterForeground: 'base.blues.blue600',
      letterItemForeground: 'base.neutrals.white',
      pageLinkForeground: 'base.neutrals.gray200',
    },
    category: {
      filtersBorder: 'base.neutrals.gray900',
      headingBg: 'base.neutrals.gray850',
      navActiveItem: 'base.blues.blue300',
      navDeepSubcategoryBorder: 'base.neutrals.gray300',
      wishlistBoxBg: 'base.blues.blue500',
      wishlistBoxForeground: 'base.neutrals.white',
    },
    browserExtensionBanner: {
      background: 'base.blues.blue500',
      buttonBg: 'base.yellows.yellow500',
      buttonForeground: 'base.neutrals.gray750',
      textForeground: 'base.neutrals.white',
    },
    commentItem: {
      blockedContentBg: 'base.neutrals.gray800',
      border: 'base.neutrals.gray900',
      fixedBg: 'base.yellows.yellow900',
      fixedForeground: 'base.neutrals.white',
    },
    commentSignUpCallToAction: {
      background: 'base.neutrals.gray800',
    },
    cookiesPage: {
      headerBackgroundColor: 'base.blues.blue500',
      headerTitleColor: 'base.neutrals.white',
      dividerBg: 'base.neutrals.gray500',
    },
    couponsListItem: {
      titleForeground: 'base.blues.blue300',
      storeNameForeground: 'base.neutrals.gray200',
      discountForeground: 'base.blues.blue300',
      border: 'base.neutrals.gray200',
      finishedCouponDiscountForeground: 'base.neutrals.gray500',
      finishedStoreNameForeground: 'base.neutrals.gray700',
      finishedTitleForeground: 'base.neutrals.gray700',
      verifiedIconColor: 'base.greens.green500',
    },
    couponModal: {
      browserExtensionBlockBg: 'base.blues.blue900',
      browserExtensionBlockBorder: 'base.blues.blue600',
      browserExtensionBlockForeground: 'base.blues.white',
      browserExtensionBlockButtonBorder: 'base.neutrals.gray300',
    },
    couponSidebar: {
      border: 'base.neutrals.gray900',
      discountForeground: 'base.blues.blue300',
      imageBorder: 'base.neutrals.gray300',
    },
    carouselCustomDot: {
      backgroundColor: 'base.neutrals.gray700',
      activeBackgroundColor: 'base.neutrals.gray500',
    },
    divider: {
      bg: 'base.neutrals.gray900',
    },
    text: {
      lightForeground: 'base.neutrals.gray200',
      invertedForeground: 'base.neutrals.gray800',
    },
    downloadApp: {
      text: 'base.neutrals.white',
    },
    drawer: {
      background: 'base.neutrals.gray800',
      border: 'base.neutrals.gray700',
      headerForegroundLogged: 'base.neutrals.white',
      headerLoggedBg: 'base.blues.blue500',
      overlayBg: 'base.neutrals.gray900',
      overlayOpacity: '0.8',
    },
    dropdown: {
      border: 'base.neutrals.gray850',
      foreground: 'base.neutrals.gray200',
      innerBg: 'base.neutrals.gray800',
      itemBg: 'base.neutrals.gray850',
      itemBgAlt: 'base.neutrals.gray900',
      itemHover: 'base.neutrals.gray700',
      overlay: 'base.neutrals.gray900',
      overlayOpacity: '0.6',
    },
    extensionBanner: {
      background: 'base.yellows.yellow500',
    },
    featuredArticles: {
      border: 'base.neutrals.gray900',
    },
    filterOffersByCategoriesModal: {
      border: 'base.neutrals.gray900',
    },
    footer: {
      dividerBg: 'base.neutrals.gray900',
    },
    homePage: {
      offerCardBorderColor: 'base.neutrals.gray900',
    },
    howPromobitWorks: {
      iconBg: 'base.blues.blue500',
      borderTopBg: 'base.blues.blue500',
    },
    suggestNewOffer: {
      border: 'base.neutrals.gray700',
      collapseBg: 'base.neutrals.gray800',
      imageCarouselBorder: 'base.neutrals.gray700',
      photoFallbackBg: 'base.blues.blue900',
      photoFallbackIconColor: 'base.blues.blue600',
      selectedImageBorder: 'base.neutrals.gray800',
      selectedImageCarouselBorder: 'base.greens.green500',
    },
    stepper: {
      completed: {
        foreground: 'base.greens.green600',
        iconColor: 'base.greens.green500',
        iconForeground: null,
        wrapperBackground: 'base.greens.green100',
        wrapperBorderColor: null,
      },
      current: {
        foreground: 'base.neutrals.gray200',
        iconColor: 'base.neutrals.gray200',
        iconForeground: 'base.neutrals.gray800',
        wrapperBackground: null,
        wrapperBorderColor: 'base.neutrals.gray700',
      },
      not_started: {
        foreground: 'base.neutrals.gray700',
        iconColor: 'base.neutrals.gray500',
        iconForeground: 'base.neutrals.gray800',
        wrapperBackground: null,
        wrapperBorderColor: 'base.neutrals.gray700',
      },
    },
    landing: {
      dividerBg: 'base.neutrals.gray900',
      headingBackground: 'base.blues.blue500',
      partnerOffer: {
        bg: 'base.blues.blue900',
        borderColor: 'base.blues.blue500',
        foreground: 'base.blues.blue300',
      },
      textForeground: 'base.neutrals.white',
    },
    lgpdDialogBox: {
      border: 'base.neutrals.gray700',
    },
    mention: {
      foreground: 'base.blues.blue300',
    },
    mentionSuggestions: {
      background: 'base.neutrals.gray800',
      backgroundHover: 'base.neutrals.gray700',
      border: 'base.neutrals.gray850',
      divider: 'base.neutrals.gray850',
      foreground: 'base.neutrals.white',
      itemHover: 'base.neutrals.gray700',
    },
    messages: {
      foreground: 'base.neutrals.gray200',
      returnBackground: 'base.neutrals.gray800',
      dividerForeground: 'base.neutrals.gray500',
      feedbackAvatarBg: 'base.neutrals.gray850',
      feedbackAvatarForeground: 'base.neutrals.gray300',
    },
    messageTypes: {
      foreground: 'base.neutrals.gray200',
      footerForeground: 'base.neutrals.gray400',
      review: {
        text: 'base.neutrals.gray200',
      },
      approvedOfferMessage: {
        bg: 'base.yellows.yellow900',
        border: 'base.neutrals.gray700',
        gamificationForeground: 'base.blues.blue200',
      },
      blockedItemMessage: {
        bg: 'base.blues.blue800',
        iconBg: 'base.neutrals.gray400',
        iconBorder: 'base.blues.blue400',
        couponTitle: 'base.blues.blue300',
      },
      feedbackMessage: {
        titleForeground: 'base.blues.blue200',
      },
      offerReviewRatingMessage: {
        border: 'base.blues.blue800',
      },
      genericTypes: {
        sended: {
          bubbleBg: 'base.blues.blue800',
          bubbleBorder: 'base.blues.blue500',
          dateForeground: 'base.neutrals.gray250',
          foreground: 'base.neutrals.gray200',
        },
        received: {
          bubbleBg: 'base.neutrals.gray400',
          bubbleBorder: 'base.neutrals.gray700',
          dateForeground: 'base.neutrals.gray250',
          foreground: 'base.neutrals.gray200',
        },
      },
    },
    conversationsList: {
      types: {
        default: {
          bg: null,
          border: 'base.neutrals.gray850',
          iconForeground: 'base.neutrals.gray500',
        },
        selected: {
          bg: 'base.blues.blue800',
          border: 'base.neutrals.gray850',
          iconForeground: 'base.neutrals.gray500',
        },
      },
      divider: 'base.neutrals.gray850', // TODO
    },
    notification: {
      bg: 'base.neutrals.gray850',
      border: 'base.neutrals.gray700',
      boxBg: 'base.neutrals.gray700',
      readStatusPointerBg: 'base.blues.blue500',
      textForeground: 'base.neutrals.gray200',
    },
    offer: {
      border: 'base.blues.blue500',
      dividerBg: 'base.neutrals.gray900',
      firstOfferBg: 'base.yellows.yellow900',
      firstOfferForeground: 'base.neutrals.white',
      imageBg: 'base.neutrals.white',
    },
    offerPagesTabNav: {
      bg: 'base.neutrals.gray850',
      activeIconForeground: 'base.blues.blue500',
    },
    offerRelatedItems: {
      border: 'base.neutrals.gray900',
    },
    promonews: {
      bg: 'base.blues.blue700',
      foreground: 'base.neutrals.white',
    },
    rating: {
      border: 'base.neutrals.gray800',
      filledRatingStar: 'base.yellows.yellow500',
    },
    reviewItem: {
      background: 'base.neutrals.gray750',
      border: 'base.neutrals.gray850',
      headerBg: 'base.blues.blue500',
      headerForeground: 'base.neutrals.white',
    },
    sidebarLink: {
      foreground: 'base.neutrals.gray400',
    },
    storesCarousel: {
      itemWrapperBg: 'base.neutrals.gray850',
    },
    storesDropdown: {
      bg: 'base.neutrals.gray800',
      border: 'base.neutrals.gray850',
      cardBorder: 'base.neutrals.gray700',
      foreground: 'base.neutrals.gray300',
    },
    storesWithFeaturedOffers: {
      storeNameForeground: 'base.blues.blue300',
      icon: 'base.neutrals.gray200',
      border: 'base.neutrals.gray900',
    },
    suggestNewItem: {
      headingBg: 'base.blues.blue900',
    },
    suggestNewThread: {
      labelForeground: 'base.neutrals.gray200',
      text: 'base.neutrals.gray500',
    },
    searchInStoresCallToAction: {
      border: 'base.blues.blue500',
      icon: 'base.blues.blue500',
      storeBorder: 'base.neutrals.gray200',
    },
    searchWithoutResults: {
      storeItemBg: 'base.neutrals.gray750',
      icon: 'base.blues.blue500',
    },
    tag: {
      uniqueForeground: 'base.greens.green200',
    },
    timeline: {
      offerCard: {
        border: 'base.neutrals.gray900',
        commentCountForeground: 'base.neutrals.gray200',
        commentIconForeground: 'base.neutrals.gray200',
        domainBackground: 'base.neutrals.gray850',
        domainForeground: 'base.neutrals.gray300',
        titleForeground: 'base.neutrals.gray300',
      },
    },
    toast: {
      action: {
        bg: 'base.neutrals.gray250',
        border: 'base.neutrals.gray800',
        foreground: 'base.neutrals.gray800',
        linkForeground: 'base.blues.blue700',
      },
      primary: {
        bg: 'base.blues.blue700',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
      success: {
        bg: 'base.greens.green700',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
      danger: {
        bg: 'base.reds.red500',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
    },
    socialMedia: {
      bg: 'base.neutrals.gray800',
      foreground: 'base.neutrals.gray500',
    },
    shareCampaignLoginModal: {
      slideshowBg: 'base.blues.blue100',
      slideshowForeground: 'base.blues.blue900',
    },
    storeInfo: {
      linkForeground: 'base.blues.blue300',
      border: 'base.neutrals.gray900',
      checkedForeground: 'base.greens.green500',
      countForeground: 'base.blues.blue500',
      helpSignIcon: 'base.neutrals.gray500',
      storeMarketplaceForeground: 'base.neutrals.gray200',
      uncheckedForeground: 'base.neutrals.gray500',
      borderStoreSeparator: 'base.neutrals.gray700',
    },
    topbar: {
      background: 'base.neutrals.gray850',
      borderBg: 'base.neutrals.gray800',
      wishlistIcon: 'base.reds.red400',
    },
    topbarSearch: {
      border: 'base.neutrals.gray700',
      highlight: 'base.neutrals.gray700',
      suggestionsBg: 'base.neutrals.gray800',
      suggestionsBorder: 'base.neutrals.gray850',
    },
    userProfile: {
      bg: 'base.neutrals.gray800',
      border: 'base.neutrals.gray850',
      mainInfoBg: 'base.blues.blue500',
      statsForeground: 'base.blues.blue500',
    },
    wishlist: {
      dividerBg: 'base.neutrals.gray700',
      introBg: 'base.blues.blue500',
      introForeground: 'base.neutrals.white',
    },
    lastComments: {
      iconColor: 'base.neutrals.white',
      listItemBoxBg: 'base.neutrals.gray800',
      listItemImageBg: 'base.neutrals.gray200',
      listItemImageBorder: 'base.neutrals.gray700',
      listItemImageIconColor: 'base.neutrals.gray300',
      listItemBorder: 'base.neutrals.gray800',
    },
    topContributorsRanking: {
      icon: 'base.yellows.yellow500',
      topUserBg: 'base.yellows.yellow600',
      topUserDetailsBg: 'base.yellows.yellow800',
      userBg: 'base.neutrals.gray700',
      userDetailsBg: 'base.neutrals.gray750',
      userNameForeground: 'base.neutrals.white',
      userIndexForeground: 'base.neutrals.white',
    },
    threadsListItem: {
      border: 'base.neutrals.gray900',
      icon: 'base.neutrals.white',
    },
    thread: {
      borderTop: 'base.blues.blue500',
      foreground: 'base.neutrals.white',
      shareBlockBorderTop: 'base.neutrals.gray900',
      fixedTagBg: 'base.neutrals.gray800',
      fixedTagForeground: 'base.neutrals.white',
    },
    threadHead: {
      borderColor: 'base.neutrals.gray750',
    },
    border: 'base.neutrals.gray900',
    warn: 'base.yellows.yellow900',
    white: 'base.neutrals.white',
    searchQuerySuggestedCorrectionTooltip: {
      bg: 'base.greens.green500',
      foreground: 'base.neutrals.white',
    },
    webpushOptIn: {
      foreground: 'base.neutrals.gray100',
    },
  },
};

export default dark;
